import { loadStripe } from "@stripe/stripe-js";
import { useStripe, useElements, CardNumberElement, CardCvcElement, CardExpiryElement, Elements } from "@stripe/react-stripe-js";
import { typography } from "../../../styles/typography";
import colors from "../../../styles/colors";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../../../services/contants";
import { ANNUAL } from "../../../constans";
import { setSerial } from "../../../services/firestore";
const STRIPE_PRICE_MONTHLY = "price_1SSwbc7OGtj5wLlrrCQx8Qgy";
const STRIPE_PRICE_YEARLY = "price_1SSwbc7OGtj5wLlrUbJ2HbIg";
const cardIcons = [require('../images/mastercard.png'), require('../images/visa.png'), require('../images/discover.png'), require('../images/american_express.png'), require('../images/jcb.png')]

const stripePromise = loadStripe('pk_test_51S5KUG7OGtj5wLlrsOU5Fh3ln5CZRXQJMAxc8BNQpqNk57nMF1Teqetb1wNNy5P7QBczjSehRUtdtx2rABsLkrvY002D3EtkMY');


const Content = forwardRef(({ onComplete, email, plan, amount, onLoading }, ref) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const stripe = useStripe();
    const elements = useElements();

    useEffect(()=> {
        onLoading && onLoading(loading)
    }, [loading])

    useImperativeHandle(ref, () => ({
        handleStripePayment: handleStripePayment
    }))

    const handleStripeChange = (type) => (event) => {
        onComplete((prev) => ({ ...prev, [type]: event.complete }));
    };

    const handleStripePayment = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");
    
        if (!stripe || !elements) {
          setErrorMessage("Stripe has not loaded yet.");
          setLoading(false);
          return;
        }
    
        const cardElement = elements.getElement(CardNumberElement);
    
        try {
          // 1️⃣ Create payment method
          const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: "card",
            card: cardElement,
            billing_details: { email }
          });
    
          if (error) {
            setErrorMessage(error.message);
            setLoading(false);
            return;
          }
    
          // 2️⃣ Send paymentMethod.id and price to backend
          const res = await fetch(`${BACKEND_URL}/stripe/create-subscription`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email,
              paymentMethodId: paymentMethod.id,
              priceId: plan === ANNUAL ? STRIPE_PRICE_YEARLY : STRIPE_PRICE_MONTHLY,
              plan: plan,
              amount: amount
            })
          });
    
          const data = await res.json();
    
          // 3️⃣ Action needed → 3D Secure
          if (data.requiresAction) {
            const result = await stripe.confirmCardPayment(data.clientSecret);
            if (result.error) {
              setErrorMessage(result.error.message);
              setLoading(false);
              return;
            }
    
            // After 3D secure → check subscription again
            navigate("/registration_complete");
            
            return;
          }
    
          // 4️⃣ Payment success
          if (data.success) {
            navigate("/registration_complete");
            
            return;
          }
    
          // 5️⃣ Card rejected
          if (data.error) {
            setErrorMessage(data.error);
          }
        } catch (err) {
          setErrorMessage("Payment failed. Try again.");
          console.error(err);
        }
    
        setLoading(false);
      };
    

    return (
        <div style={style.container}>
            <div className="mt-32" style={{ width: '100%' }}>
                <h3 className="body_15_medium">Pay with Debit/Credit Card</h3>
                <div style={style.cardIcons} className="mt-24">
                    {cardIcons.map((card, i) => <img src={card} key={i} style={style.card} />)}
                </div>

            </div>

            <form onSubmit={handleStripePayment} className="mt-24">
                <div className="caption_12_regular">*Card number</div>
                <div style={style.inputContaier}>
                    <CardNumberElement
                        options={{ style: style.elementStyle, showIcon: true }}
                        onChange={handleStripeChange('number')}
                    />
                </div>

                <div style={style.cardInputs}>
                    <div style={{ flex: 0.5 }}>
                        <div className="caption_12_regular">*Expiration date</div>
                        <div style={style.inputContaier}>
                            <CardExpiryElement
                                options={{ style: style.elementStyle, showIcon: true }}
                                onChange={handleStripeChange('expiry')}
                            />
                        </div>
                    </div>

                    <div style={{ flex: 0.5 }}>
                        <div className="caption_12_regular">*Security code</div>
                        <div style={style.inputContaier}>
                            <CardCvcElement
                                options={{ style: style.elementStyle }}
                                onChange={handleStripeChange('cvc')}
                            />
                        </div>
                    </div>
                </div>

                {errorMessage && (
                    <p className="text-red-600 text-sm">{errorMessage}</p>
                )}

            </form>
        </div>
    )
})

const style = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    inputContaier: {
        border: '1px solid #23292E',
        borderRadius: 10,
        padding: '0px 16px',
        marginTop: 10
    },
    cardInputs: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        gap: 12,
        marginTop: 32
    },
    elementStyle: {
        base: {
            ...typography.body["15_regular"],
            color: "#fff",
            lineHeight: '48px',
            '::placeholder': {
                color: colors.mono500,
            }
        },
        invalid: {
            color: "#fa755a",
        },
    },
    card: {
        height: 29,
        width: 'auto'
    },
    cardIcons: {
        display: 'flex',
        gap: 10,
        width: '100%'
    }
}

const CardPayment = ({ onComplete, email, plan, onLoading }, ref) => {
    // useImperativeHandle(ref, () => ({
    //     handleStripePayment: ()=> {
    //         console.log("handleStripePayment yes")
    //     }
    // }))
    return <Elements stripe={stripePromise}>
        <Content onComplete={onComplete} email={email} plan={plan} onLoading={onLoading} ref={ref} />
    </Elements>
}
export default forwardRef(CardPayment)